import { useState, useEffect } from 'react';
import { useAuth } from '../guards/context';
import { consumer } from '../connectors';

export const useProfile = () => {
  const { user, signin } = useAuth();
  const [profilePhotoState, setProfilePhotoState] = useState<string>('');
  const profile_photo = localStorage.getItem('profile_photo');

  useEffect(() => {
    if (user?.id) {
      loadInfo();
    }
  }, [user, profile_photo]);

  const loadInfo = async () => {
    try {
      const response = await consumer('GET', `/users/${user?.id}`);
      localStorage.setItem('profile_photo', response.message.profilePhotoPath);
      setProfilePhotoState(response.message.profilePhotoPath);
    } catch (error) {
      console.log('error loading profile info');
    }
  };

  const switchProfile = async (teamId: number) => {
    try {
      const { message } = await consumer('POST', `/users/switch-team/${teamId}`);
      signin(message, false);
    } catch (error) {
      throw error;
    }
  };

  return {
    profilePhotoState,
    profile_photo,
    switchProfile,
    loadInfo
  };
}; 